import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Button } from '@material-ui/core'
import ShoppingCart from '@material-ui/icons/ShoppingCartOutlined'
import CircularProgress from '@material-ui/core/CircularProgress'
import connectPropTypes from '../utilities/connectPropTypes'
import styles from './BuyButton.icss'

class BuyButton extends React.Component {
	constructor(props) {
		super(props)
		this.state = { hasClicked: false }
		this.handleClick = this.handleClick.bind(this)
	}

	handleClick() {
		if (!this.state.hasClicked) {
			this.setState({ hasClicked: true })
			const { buyUrl, buyButtonClick, buyItemKey, buyBrand } = this.props
			//	Ref: https://en.wikipedia.org/wiki/UTM_parameters
			const addTrackingParameters = url => `${url + (url.indexOf('?') === -1 ? '?' : '&')}utm_source=kitfit&utm_medium=cpc&utm_campaign=kitfit&utm_content=itemPage&utm_term=${buyItemKey}`
			const url = addTrackingParameters(buyUrl)
			buyButtonClick({ buyClick: { url, itemKey: buyItemKey, brand: buyBrand } })
		}
	}

	render() {
		const baseClasses = [...this.props.smallerButtons ? [styles.smallerButtons] : [], ...!this.props.showIcons ? [styles.noIcon] : []]

		return (
			<Button variant="contained" classes={{ ...this.props.classes, root: classNames(styles.compactButton, styles.buyButton, ...baseClasses, ...(this.props.classes && this.props.classes.root ? this.props.classes.root : [])) }} onClick={this.handleClick}>
				{this.props.showIcons && !this.state.hasClicked && <ShoppingCart classes={{ root: styles.icon }} />}
				{this.props.showIcons && this.state.hasClicked && <CircularProgress className={styles.loading} size={24} thickness={4} />}
				{this.context.translate('Buy')}
			</Button>
		)
	}
}

BuyButton.propTypes = {
	buyButtonClick: PropTypes.func.isRequired,
	buyUrl: PropTypes.string,
	buyItemKey: PropTypes.string,
	buyBrand: PropTypes.string,
	classes: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	smallerButtons: PropTypes.bool,
	showIcons: PropTypes.bool
}

BuyButton.defaultProps = {
	buyUrl: undefined,
	buyItemKey: undefined,
	buyBrand: undefined,
	classes: {},
	smallerButtons: false,
	showIcons: true
}

BuyButton.contextTypes = {
	translate: PropTypes.func
}

export default connectPropTypes(BuyButton)



// WEBPACK FOOTER //
// ./src/components/BuyButton.jsx